import { render } from "./ReferencesContent.vue?vue&type=template&id=a7b1fd18&ts=true"
import script from "./ReferencesContent.vue?vue&type=script&lang=ts"
export * from "./ReferencesContent.vue?vue&type=script&lang=ts"

import "./ReferencesContent.vue?vue&type=style&index=0&id=a7b1fd18&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__